import React, { ComponentProps } from 'react';
import BodyText from '../../../atoms/BodyText';

type Props = {
  children: React.ReactNode;
} & ComponentProps<typeof BodyText>;

const TextMessage = ({ children, ...rest }: Props) => (
  <BodyText variant="body2" color="inherit" {...rest}>
    {children}
  </BodyText>
);

export { TextMessage };
